export const DEFAULT_MCC_CONFIG = {
  pix: {
    "1": {
      value: 0,
      rateType: "PERCENTAGE",
      valueLimit: 1000,
    },
  },
  debit: {
    "1": {
      value: 0,
      rateType: "PERCENTAGE",
    },
  },
  bankSlip: {
    "1": {
      value: 0,
      rateType: "PERCENTAGE",
      valueLimit: 1000,
    },
  },
  creditCard: {
    default: {
      pos: {
        default: {
          sellerRates: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
        },
      },
      tap: {
        default: {
          sellerRates: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
        },
      },
      online: {
        default: {
          sellerRates: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
        },
      },
    },
  },
};

export const DEFAULT_COMPANY_PLAN = {
  name: "",
  tax: {
    taxConfigsByMcc: {
      default: DEFAULT_MCC_CONFIG,
    },
  },
};
